<template>
  <div id="LLI">
    <div class="LLIprogram">
      <template v-for="(itemp, ip) in level.program" :key="ip">
        <el-card class="LLIprogramcard">
          <div class="LLIprogramcardcontext">
            <h4>{{ itemp.title }}</h4>
            {{ itemp.text }}
          </div>
        </el-card>
      </template>
    </div>
    <div class="LLIgoals">
      <template v-for="(itemg, ig) in level.goals" :key="ig">
        <el-card class="LLIgoalcard">
          <img :src="serverUrl+'/'+itemg.img" style="background-repeat: no-repeat;" />
          <div class="LLIgoalcardcontext">
            <h3>{{ itemg.title }}</h3>
            {{ itemg.text }}
          </div>
        </el-card>
      </template>
    </div>
    <el-timeline>
      <el-timeline-item
        v-for="(item, i) in level.topics"
        :key="i"
        center
        hollow="true"
        type="danger"
      >
        <el-card class="LLItopiccard">
          <div class="LLItitle" v-html="item.title"></div>
          <ul>
            <li v-for="(item2, i2) in item.items" :key="i2">
              {{ item2 }}
            </li>
          </ul>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useMyStorage } from "@/store/global";
export default defineComponent({
  props: {
    idl: {
      type: Number,
      requred: true,
    },
  },
  name: "LevelInfo",
  setup(props) {
    console.log(props.idl)
    const store = useMyStorage();
    const level = ref(store.learningLevels[props.idl]);
    const serverUrl=store.ServerUrl;
    return { level, serverUrl };
  },
});
</script>
<style lang="scss">
#LLI {
  .LLIprogram {
      .LLIprogramcard{
          width: 45%;
          margin:2%;
          display: inline-block;
          height: 140px;
      }
  }
  .LLItopiccard {
    width: 775px;
    .LLItitle {
      //   font-family: Montserrat;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
      letter-spacing: 0em;
      text-align: left;
      color: #222;
      margin-bottom: 15px;
    }
    li {
      list-style-image: url(~@/assets/images/arrow-right.svg);
      font-size: 20px;
      margin-bottom: 5px;

    }
  }

  .LLIgoals {
    margin-left: 40px;
    margin-bottom: 30px;
    .LLIgoalcard {
      display: inline-block;
      width: 250px;
      height: 250px;
      margin: 10px;
      img{
        background-repeat: no-repeat;
      }
    }
  }
}
</style>
